export default "__VITE_ASSET__6b8e4fe5__"